<script>
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {onMounted, onUnmounted, ref, watch} from "vue";
import $ from "jquery";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";

export default {
  name: "MyAuctions",
  components: {LoadingPage},
  setup() {

    let loading = ref(false)
    let bids = ref([])
    let wallet = ref(0)

    function load_bids() {

      loading.value = true

      FreeWorld.Heisenberg({type: 'my'}, 'bids', true).then((res) => {

        loading.value = false

        bids.value = res.data.bids
        wallet.value = res.data.wallet

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_bids)
      })

    }

    load_bids()

    function accept_auction(item) {

      loading.value = true
      FreeWorld.Heisenberg({bid: item.id, action: 'pay'}, 'bids_act', true).then((res) => {
        loading.value = false
        if (res.data.status === 'ok') {
          Swals.Done('پرداخت شما با موفقیت انجام شد')
          load_bids()
          open_products(item)
        } else if (res.data.status === 'something is wrong') {
          Swals.Fault('متاسفانه مشکلی پیش آمده است!')
        } else {
          Swals.Fault('متاسفانه پرداخت شما انجام نشد')
        }
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, () => {
          accept_auction(item)
        })
      })

    }

    function open_products(item) {

      let div = document.getElementById('product' + item.id)
      let info = $("#info_prod" + item.id)
      let icon = $("#icon" + item.id)

      let rootFontSize = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('font-size'));
      let heightInRem = div.scrollHeight / rootFontSize;
      heightInRem = heightInRem.toFixed(1);

      if (div.style.height === heightInRem + 'rem') {
        window.innerWidth > 800 ? div.style.height = '14.5rem' : div.style.height = '13rem'
        info.removeClass('animate__fadeIn').addClass('animate__fadeOut')
        icon.removeClass('rotate_icon').addClass('min_rotate_icon')
      } else {
        // if (item.winpay === 0 && item.my.result === 'اتمام - برنده شده اید'){
        //   div.style.height = '39rem'
        // }else {
        //   div.style.height = '27.5rem'
        // }

        div.style.height = heightInRem + 'rem'
        info.removeClass('animate__fadeOut').addClass('animate__fadeIn')
        icon.removeClass('min_rotate_icon').addClass('rotate_icon')
      }

    }


    let windowWidth = ref()
    const handleResize = () => {
      windowWidth.value = window.innerWidth
    };

    onMounted(() => {
      window.addEventListener('resize', handleResize);
    })

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });

    watch(() => windowWidth.value, (newWidth) => {
      bids.value.forEach((item) => {
        let div = document.getElementById('product' + item.id);
        if (div) {
          newWidth > 800 ? div.style.height = '14.5rem' : div.style.height = '13rem';
        }
      });
    })


    // function decreaseTimer() {
    //   // برای هر آیتم در آرایه bids
    //   bids.value.forEach(item => {
    //     if (item.timer !== 'expired') {
    //       // تقسیم تایمر به ساعت، دقیقه و ثانیه
    //       let [hours, minutes, seconds] = item.timer.split(':').map(Number);
    //       // کاهش یک ثانیه از تایمر
    //       seconds--;
    //       // اگر زمان به صفر رسید، زمان را به 0:0:0 تنظیم کنید
    //       if (seconds < 0) {
    //         seconds = 59;
    //         minutes--;
    //         if (minutes < 0) {
    //           minutes = 59;
    //           hours--;
    //           if (hours < 0) {
    //             hours = 0;
    //             minutes = 0;
    //             seconds = 0;
    //             // اگر زمان به پایان رسید، اقدامات مورد نظر را انجام دهید، مثلاً توقف تایمر
    //           }
    //         }
    //       }
    //       // به‌روزرسانی تایمر در آرایه data
    //       item.timer = `${hours}:${minutes}:${seconds}`;
    //     }
    //   });
    //
    // }
    //
    // let update_timer = null
    //
    // onMounted(() => {
    //   update_timer = setInterval(decreaseTimer, 1000);
    // })
    // onBeforeUnmount(() => {
    //   clearInterval(update_timer)
    // })

    return {

      loading,
      bids,
      open_products,
      wallet,
      accept_auction,
    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">مزایده های شرکت شده</p>
        <router-link :to="{name:'ProfilePage'}">
          <img class="svg-arrow" src="../assets/img/arrow.svg" alt="">
        </router-link>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div v-if="bids.length === 0 && !loading" style="height: 45vh"
         class="d-flex justify-content-center align-items-end w-100 animate__animated animate__fadeIn">
      <div class="d-flex flex-column align-items-center justify-content-end">
        <img src="../assets/img/auction.png" class="mb-3 w-25" alt="">
        <p class="font-3 font-bold">مزایده ای برای نمایش وجود ندارد!</p>
      </div>
    </div>

    <div v-else class="w-100 p-body ">

      <div v-for="item in bids" :key="item.id" class="position-relative animate__animated animate__fadeInRight">

        <div :id="'product' + item.id"
             class="overflow-hidden product text-decoration-none bg-white mb-4-5 shadow-custom p-2 rounded-4 position-relative">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column justify-content-around w-60">
              <div class="overflow-hidden">
                <p class="font-bold font-5" :class="{'txtoverflow': item.name.length > 30}">{{ item.name }}</p>
              </div>

              <div class="overflow-hidden">
                <p class="font-5 my-2" :class="{'txtoverflow': item.brand.length > 25}">از برند {{ item.brand }}</p>
              </div>

              <div class="d-flex align-items-end mb-2">
                <img src="../assets/img/package2.png" class="icon-size-1">

                <p style="white-space: nowrap" class="font-6 mx-1">حجم محصول مزایده :</p>

                <div class="overflow-hidden">
                  <p :class="item.pnum.toString().length + item.unit.length > 10 ? 'txtoverflow':''"
                     class="font-5 font-color font-bold d-flex align-items-center">
                    <span class="mx-1">{{ item.pnum }} عدد</span>
                    <span class="">{{ item.unit }}</span>
                  </p>
                </div>
              </div>

              <div class="d-flex align-items-end">
                <img src="../assets/img/credit2.png" class="icon-size-1">

                <p class="font-6 mr-1">قیمت پایه مزایده :</p>

                <p :class="item.price.toString().length > 10 ? 'txtoverflow':''"
                   class="mx-1 font-color font-bold d-flex align-items-end">
                  <span class="font-5">{{ item.price.toLocaleString() }}</span>
                  <span class="font-6 mr-1">تومان</span>
                </p>
              </div>

              <div class="div_hr my-2"></div>

            </div>


            <div class="img_prod rounded-3 animated-background">
              <img class="w-100 h-100 rounded-3" :src="item.pic" alt="">
            </div>

          </div>

          <div class="d-flex align-items-center justify-content-between mt-2 mb-4-5">

            <div class="d-flex align-items-center">
              <img class="icon-size-0-5 ml-2" src="../assets/img/store_color.svg" alt="">
              <div class="overflow-hidden d-flex align-items-center">
                <p class="font-5" :class="{'txtoverflow': item.shopname.length > 30}">{{ item.shopname }}</p>
              </div>
            </div>

            <div v-if="item.timer === 'expired' || item.timer === '00:00:00'"
                 class="text-decoration-none text-black bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">
              مزایده به پایان رسیده
            </div>
            <router-link v-else :to="{name:'AuctionInformation' , params:{bid:item.id}}"
                         class="text-decoration-none text-black bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">
              ورود به مزایده
            </router-link>
          </div>

          <div class="mb-4">
            <div :id="'info_prod' + item.id" class="animate__animated rounded-3 p-body py-3 drop_shadow">
              <div class="d-flex justify-content-start align-items-center mb-2">
                <img src="../assets/img/clock.png" class="icon-size-1">
                <p class="m-0 me-2 font-5">تاریخ مشارکت شما :</p>
                <p class="m-0 me-2 font-5 font-bold font-color">{{ item.my.my_date }}</p>
              </div>

              <div class="d-flex justify-content-start align-items-center mb-2">
                <img src="../assets/img/bid.png" class="icon-size-1">
                <p class="mx-2 font-5">مبلغ پرداختی :</p>
                <div class="d-flex justify-content-center align-items-center">
                  <p class="font-4 font-bold font-color">{{ item.my.my_pay.toLocaleString() }}</p>
                  <p class="font-5 mr-1 font-bold font-color">تومان</p>
                </div>
              </div>

              <div class="d-flex justify-content-start align-items-center mb-2">
                <img src="../assets/img/increase.png" class="icon-size-1">
                <p class="mx-2 font-5">پیشنهاد شما برای مزایده :</p>
                <div v-if="item.my.my_offer !== null" class="d-flex justify-content-center align-items-center">
                  <p class="font-4 font-bold font-color">{{ item.my.my_offer.toLocaleString() }}</p>
                  <p class="font-5 mr-1 font-bold font-color">تومان</p>
                </div>
                <p v-else class="font-5 font-color">پیشنهادی ثبت نکرده اید</p>
              </div>

              <div class="d-flex justify-content-start align-items-center mb-2">
                <img src="../assets/img/information.svg" class="icon-size-1">
                <p class="mx-2 font-5">وضعیت مزایده :</p>

                <p :class="item.my.result === 'اتمام - برنده شده اید' ? 'font-color-green':'font-color-red'"
                   class="font-5 mr-1 font-bold">{{ item.my.result }}</p>
              </div>
            </div>

            <div v-if="item.winpay === 0 && item.my.result === 'اتمام - برنده شده اید'" :id="'info_prod' + item.id"
                 class="animate__animated drop_shadow rounded-3 p-body py-3 mt-3">
              <div class="d-flex align-items-center justify-space-between">
                <div class="d-flex align-items-center">
                  <img class="icon-size-1" src="../assets/img/wallet.png" alt="">

                  <p class="font-4 font-color mx-1">موجودی کیف پول شما :</p>

                  <p class="font-4 font-color font-bold">{{ wallet.toLocaleString() }} تومان</p>
                </div>

              </div>

              <div class="d-flex justify-content-center mt-3">
                <router-link :to="{name:'WalletPage'}"
                             class="p-2 font-5 w-50 text-decoration-none rounded-2 text-center bg-green text-white">
                  افزایش کیف پول
                </router-link>
              </div>

              <div class="d-flex justify-content-center mt-3">
                <v-btn @click="accept_auction(item)" class="w-60 ma-auto bg-green">پرداخت</v-btn>
              </div>
            </div>
          </div>

        </div>

        <div @click="open_products(item)"
             class="icon_show rounded-pill bg-white shadow-custom position-absolute d-flex justify-content-center align-items-center">
          <img :id="'icon' + item.id" src="../assets/img/bottomarrow.png"
               class="position-absolute min_rotate_icon icon-size-1">
        </div>
      </div>

    </div>

  </div>

</template>


<style scoped>

.icon_show {
  left: 50%;
  bottom: -1.5rem;
  transform: translate(-50%, 0);
  padding: 1.5rem;
}

.product {
  transition: .5s;
}

@media (min-width: 800px) {
  .img_prod {
    width: 20% !important;
    height: 10.5rem !important;
  }

  .product {
    height: 14.5rem;
  }
}

@media (max-width: 799px) {
  .product {
    height: 13rem;
  }
}

.img_prod {
  width: 35%;
  height: 8.5rem;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}


.drop_shadow {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0px 55px -12px inset, rgba(0, 0, 0, 0.3) 0px 0px 0px 0px inset, inset 0 0 15px 0 #c7c7c7;
}

.rotate_icon {
  transform: rotate(180deg);
  transition: .5s;
}

.min_rotate_icon {
  transform: rotate(0deg);
  transition: .5s;
}

</style>